<!-- @format -->

@if (this.service.query.select() | async; as wizardData) {
  <div id="student-application" class="container student-application prior-learning-inclusion-application">
    <div class="row">
      <div class="offset-md-1 col-md-10 offset-lg-2 col-lg-8">
        <div class="form-group-mimic">
          <sis-wizard-progress [stepKeys]="wizardStepKeys" [currentStep]="currentStep()"></sis-wizard-progress>
        </div>
        @if (isFirstStep()) {
          <app-custom-attainment-basic-info-edit
            [planId]="plan?.id"
            [customStudyDraft]="getCustomStudyDraft(wizardData)"
            [workflowApplication]="getInclusionWorkflowApplication(wizardData)"
            (exit)="exit()"
            (continue)="continueAfterCustomAttainmentBasicInfoEdit($event)">
          </app-custom-attainment-basic-info-edit>
        }
        @if (currentStep() === 1) {
          <app-prior-learning-and-attachments-edit
            type="INCLUDE"
            [customStudyDraft]="getCustomStudyDraft(wizardData)"
            (exit)="exit()"
            (previous)="previous()"
            (continue)="continue()">
          </app-prior-learning-and-attachments-edit>
        }
        @if (isLastStep()) {
          <app-prior-learning-application-confirmation
            [disableButtons]="uploading"
            (exit)="exit()"
            (previous)="previous()"
            (submit)="submit()">
          </app-prior-learning-application-confirmation>
        }
      </div>
    </div>
  </div>
}
